import { useParams, Navigate, Link } from 'react-router-dom';
import { SizingLanding } from '@/components/SizingLanding';
import { parseGuideSlug, getRelatedGuides } from '@/data/seoVariables';
import { chooseTarget, requiredCfm } from '@/lib/calculator';

export default function GuidePage() {
  const { slug = '' } = useParams<{ slug: string }>();
  const params = parseGuideSlug(slug);
  if (!params) return <Navigate to="/guides" replace />;
  const { size, roomType, problem } = params;
  const target = chooseTarget(problem.concerns);
  const cfmNeeded = target ? Math.ceil(requiredCfm({ areaSqFt: size, ceilingFt: roomType.defaultCeilingHeight }, target.each) - 1e-9) : null;
  const related = getRelatedGuides(params, 6);
  return (
    <SizingLanding
      path={`/guide/${slug}`}
      title={`${size} sq ft ${roomType.name.toLowerCase()} — ${problem.name.toLowerCase()}: CADR needed`}
      h1={`Air purifier sizing: ${size} sq ft ${roomType.name.toLowerCase()}, ${problem.name.toLowerCase()}`}
      description={`${problem.name} in a ${size} ft² ${roomType.name.toLowerCase()} (${roomType.defaultCeilingHeight} ft ceiling): ${cfmNeeded ?? '—'} CFM target with the maths shown, plus practical limits.`}
      areaSqFt={size}
      ceilingFt={roomType.defaultCeilingHeight}
      concerns={problem.concerns}
      intro={<p>{problem.description}</p>}
      notes={problem.tips}
    >
      {related.length > 0 && (
        <section className="mt-8">
          <h2 className="text-xl font-bold text-foreground mb-2">Related</h2>
          <ul className="grid sm:grid-cols-2 gap-2 text-sm">
            {related.map((g) => <li key={g.slug}><Link to={g.path} className="text-primary underline">{g.size} sq ft {g.roomType.name.toLowerCase()} — {g.problem.name.toLowerCase()}</Link></li>)}
          </ul>
        </section>
      )}
    </SizingLanding>
  );
}
